// extracted by mini-css-extract-plugin
module.exports = {"picker":"EquipeModalContent_picker__2mgrX"};